import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDotSuccess = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 4,
		cy: 4,
		r: 3.5,
		fill: "#44C1A8",
		stroke: "#278B77"
	})
});
export default SvgDotSuccess;
